import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { DEFAULT_PRODUCT_TYPES } from "resource-planner-model";
import { AppState } from "../redux/AppTypes";
import { useAllCustomersSelector } from "../customers/useAllCustomers";
import { useAllTeamsSelector } from "./useAllTeams";

const applicationConfigSelector = (state: AppState) =>
  state.applicationConfig?.item || {
    productTypes: DEFAULT_PRODUCT_TYPES,
  };

export const useProductTypesSelector = createSelector(
  applicationConfigSelector,
  useAllTeamsSelector,
  useAllCustomersSelector,
  (config, teams, customers) => {
    const productTypes = new Set<string>();
    (config.productTypes || [])
      .filter((productType) => !productType.archived)
      .sort((left, right) => left.order - right.order)
      .forEach((productType) => productTypes.add(productType.label));
    Object.values(teams).forEach((team) =>
      (team.productTypes || []).forEach((productType) =>
        productTypes.add(productType)
      )
    );
    Object.values(customers).forEach((customer) =>
      (customer.productTypes || []).forEach((productType) =>
        productTypes.add(productType)
      )
    );
    return Array.from(productTypes);
  }
);

export default function useProductTypes(): string[] {
  return useSelector(useProductTypesSelector);
}
